export default __webpack_public_path__ + "static/media/Integration_Line.02498710.svg";